/**
 * Get table headers.
 *
 * @returns array of table headers.
 */
export const CA_HEADERS = {
  growthPrediction: ['Pre-money', 'Total round', 'Post-money', 'Exit value','Exit probability'],
  investmentAllocation: ['Post-money', 'Exit value', 'Exit probability', 'Potential multiple', 'Investment allocation'],
};
